import { colors } from 'styles/theme/colors';
import { typography } from 'styles/theme/typography';

interface ITextOptions {
  size?: string;
  font?: string;
  height?: string;
  spacing?: string;
  color?: string;
  fontWeight?: string;
}

export const wpx = (value: string) => (/px$/i.test(value) ? value : `${value}px`);

export const weight = (style = 'sans', fontWeight = 'default') =>
  typography.fontFamilies[style][fontWeight];

export const light = (style: string) => weight(style, 'light');
export const medium = (style: string) => weight(style, 'medium');
export const bold = (style: string) => weight(style, 'bold');
export const raw = (style: string) => weight(style, 'raw');

export const getColor = (color: string) => {
  if (typeof color !== 'string') return color;

  return colors[color] || color;
};

export const getWeight = (fontWeight: string) => {
  if (typeof fontWeight !== 'string') return fontWeight;

  return fontWeight;
};

const getTextStyle = ({
  size = typography.base.fontSize,
  font = typography.base.font,
  height = typography.base.lineHeight,
  spacing = typography.base.letterSpacing,
  color,
  fontWeight,
}: ITextOptions) =>
  `
   ${font};
    font-size: ${wpx(size)};
    line-height: ${height};
    letter-spacing: ${wpx(spacing)};
    ${color ? `color: ${getColor(color)};` : ''}
    ${fontWeight ? `font-weight: ${getWeight(fontWeight)};` : ''}
  `;

export const variableFontRegular = (options?: ITextOptions) => {
  return getTextStyle({ ...options, font: light('sans') });
};

export const variableFontMedium = (options?: ITextOptions) =>
  getTextStyle({ ...options, font: medium('sans') });

// this option has no specific font-weight attached
export const variableFont = (options?: ITextOptions) =>
  getTextStyle({ ...options, font: raw('sans') });
